const formatCompanyString = (input: string) => {
	let output = '';

	for (let i = 0; i < input.length; i++) {
		const char = input[i];

		// Insert space before uppercase letters (excluding the first character)
		if (i > 0 && char === char.toUpperCase()) {
			output += ' ' + char;
		} else {
			output += char;
		}
	}

	return output;
};

export const generateAvailableToJoinString = (val: string) => {
	return val.replaceAll('_', ' ');
};

export const generateCurrentSalaryString = (salary: number) => {
	if (salary) {
		return `₹ ${salary} LPA`;
	} else {
		return '-';
	}
};

export const generateExpectedSalaryString = (min: number, max: number) => {
	if (max) {
		return `₹ ${min} - ${max} LPA`;
	} else if (min && max === 0) {
		return `₹ ${min} LPA`;
	} else {
		return '-';
	}
};

export const generateCompanyTypePreferencesString = (values: string[]) => {
	if (values.length) {
		return values.map(company => formatCompanyString(company)).join(', ');
	} else {
		return '-';
	}
};

export const generateCitiesComfortableWorkingInString = (values: string[]) => {
	if (values.length) {
		return values.map(i => i.split(', ')[0]).join(', ');
	} else {
		return '-';
	}
};
